const urlImages = "/assets/images/modules/section_1/";

export const Section1 = {
  Responses: {
    title_correct_q01: "Bravo&nbsp;!",
    title_not_correct_q01: "Cette affirmation était pourtant juste&nbsp;!",
    text_q01: "On distingue en effet les plaies aiguës d’apparition soudaine et de courte durée " +
      "<span class=\"fw-bold\">(< 4 semaines)</span> " +
      "des plaies chroniques dont le délai de cicatrisation est allongé " +
      "<span class=\"fw-bold\">(≥ 4 à 6 semaines)</span>.<sup>1</sup>",
    title_correct_q02: "Bien joué&nbsp;!",
    title_not_correct_q02: "Chaque erreur est une étape vers la maitrise&nbsp;!",
    text_q02: "Le processus de cicatrisation est un processus naturel multifactoriel pouvant se définir comme la" +
      " réponse élaborée par la peau à toute atteinte de son intégrité.<sup>1</sup>",
    image_q02: urlImages + "01sec02q_img_resp.jpg",
    title_correct_q03: "Quelle maîtrise&nbsp;!",
    title_not_correct_q03: "Pas tout à fait&nbsp;!",
    text_q03: "En général, les 3 phases de la cicatrisation sont la détersion suivie de la granulation puis de l’épidermisation.<sup>1</sup>",
    image_q03: urlImages + "01sec03q_img_resp.png",
    title_correct_q04: "Exactement&nbsp;!",
    title_not_correct_q04: "Pas facile cette question&nbsp;!",
    text_q04: "Tous ces éléments déterminent un mode de cicatrisation particulier définissant un " +
      "« <span class=\"fw-bold\">aléa cicatriciel individuel multifactoriel</span> ».<sup>1</sup>",
    title_correct_q05: "C’est impressionnant&nbsp;!",
    title_not_correct_q05: "Presque&nbsp;!",
    text_q05: "Seule l’hypertension artérielle n’influencera pas le choix du pansement. Tous les autres critères" +
      " comme l’aspect, la couleur, l’odeur, la localisation de la plaie ou encore la quantité d’exsudat sont" +
      " déterminants.<sup>1-3</sup>",
  },
  EndTexts:{
    title_correct_end01: "Quel coup de maitre&nbsp;!",
    title_not_correct_end01: "C’est un bon début&nbsp;!",
    text_correct_end01: "Vous pouvez continuer à en apprendre plus sur la plaie via le module <span class='d-block fw-bold color-red'>«&nbsp;Bienvenue sur l’échiquier&nbsp;»</span> ou vous pouvez directement passer au module <span class='d-block fw-bold color-red'>«&nbsp;Choisir sa stratégie gagnante&nbsp;»</span>.",
    text_not_correct_end01: "La suite du parcours vous aidera à renforcer vos connaissances sur la cicatrisation."
  }
}
